import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useMyContext } from '../../../../context/MyContext';
import '../../../../css/custom-scrollbar.css';
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';
import { Base_Url, shipmentList, deleteShipment, priceEstimator, shipmentlabel, bulkshipmentlabel, Url_For_View_Document } from '../../../../config/config';
import ViewAllShipment from '../../../../component/b2c/models/ViewAllShipment';
import ViewRateForwardShipment from '../../../../component/b2c/models/ViewRateForwordShipmet';
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { FaList, FaHourglassHalf, FaClipboardList, FaTruck, FaDownload, FaShippingFast, FaTimesCircle } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import { FaShopify } from "react-icons/fa";
import { SiWoocommerce } from "react-icons/si";
import Pagination from '@mui/material/Pagination';
import { RxCross2 } from "react-icons/rx";
import { FaEye } from "react-icons/fa";
import { FaTrash, FaCopy } from "react-icons/fa";

const AllShipment = () => {
  const [allData, setAllData] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isloading, isSetLoading] = useState(false);
  const [isMobileCardView, setIsMobileCardView] = useState(false);

  const [activeTab, setActiveTab] = useState('all orders');
  const [searchTerm, setSearchTerm] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const limit = 15;

  const [selectedRowsForShip, setSelectedRowsForShip] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [selectedShipment, setSelectedShipment] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpenForShip, setIsPopupOpenForShip] = useState(false);

  const { isDarkMode, isToggleSidebar, setorderId } = useMyContext();
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  const navigateForTrack = useNavigate();

  useEffect(() => {
    const checkScreen = () => setIsMobileCardView(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    fetchAllShipments();
  }, []);

  const fetchAllShipments = async () => {
    try {
      setIsPageLoading(true);
      const response = await fetch(`${Base_Url}${shipmentList}?page=1&limit=20000`, {
        method: 'GET',
        headers: { token: token || '', cus_id: cusid || '', 'Content-Type': 'application/json' },
      });
      const result = await response.json();
      setAllData(result?.data || []);
    } catch (err) {
      toast.error("Failed to load shipments");
    } finally {
      setIsPageLoading(false);
    }
  };

  const getTabCount = (tabKey) => {
    return allData.filter(item => {
      if (tabKey === 'all orders') return true;
      if (tabKey === 'Add Shipment list' || tabKey === 'pending') return item.status?.toLowerCase().includes('pending');
      if (tabKey === 'new order') return item.status?.toLowerCase() === 'neworder';
      if (tabKey === 'process order') return item.status?.toLowerCase().includes('pickup') || item.status?.toLowerCase().includes('scheduled');
      if (tabKey === 'manifest list') return item.status?.toLowerCase() === 'manifested';
      if (tabKey === 'failed') return item.status?.toLowerCase().includes('failed') || item.status?.toLowerCase().includes('cancel');
      if (tabKey === 'shopify') return item.partner?.toLowerCase() === 'shopify';
      if (tabKey === 'woocommerce') return item.partner?.toLowerCase() === 'woocommerce';
      return false;
    }).length;
  };

  const filteredData = useMemo(() => {
    let data = [...allData];
    switch (activeTab) {
      case 'Add Shipment list':
      case 'pending':
        data = data.filter(item => item.status?.toLowerCase().includes('pending')); break;
      case 'new order':
        data = data.filter(item => item.status?.toLowerCase() === 'neworder'); break;
      case 'process order':
        data = data.filter(item => item.status?.toLowerCase().includes('pickup') || item.status?.toLowerCase().includes('scheduled')); break;
      case 'manifest list':
        data = data.filter(item => item.status?.toLowerCase() === 'manifested'); break;
      case 'failed':
        data = data.filter(item => item.status?.toLowerCase().includes('failed') || item.status?.toLowerCase().includes('cancel')); break;
      case 'shopify':
        data = data.filter(item => item.partner?.toLowerCase() === 'shopify'); break;
      case 'woocommerce':
        data = data.filter(item => item.partner?.toLowerCase() === 'woocommerce'); break;
      default: break;
    }
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      data = data.filter(row =>
        row.order_id?.toString().toLowerCase().includes(term) ||
        row.first_name?.toLowerCase().includes(term) ||
        row.phone?.includes(term)
      );
    }
    return data;
  }, [allData, activeTab, searchTerm]);

  const paginatedData = filteredData.slice((currentPage - 1) * limit, currentPage * limit);
  const totalPages = Math.ceil(filteredData.length / limit);

  useEffect(() => setCurrentPage(1), [activeTab, searchTerm]);

  const handleRowSelectForShip = (orderId, fullRow) => {
    if (selectedRowsForShip.includes(orderId)) {
      setSelectedRowsForShip(prev => prev.filter(id => id !== orderId));
      setSelectedRowsData(prev => prev.filter(row => row.order_id !== orderId));
    } else {
      setSelectedRowsForShip(prev => [...prev, orderId]);
      setSelectedRowsData(prev => [...prev, fullRow]);
    }
  };

  const handleSelectAllForShip = (checked) => {
    if (checked) {
      const pendingRows = paginatedData.filter(row => row.status?.toLowerCase().includes('pending'));
      setSelectedRowsForShip(pendingRows.map(row => row.order_id));
      setSelectedRowsData(pendingRows);
    } else {
      setSelectedRowsForShip([]);
      setSelectedRowsData([]);
    }
  };

  const handleRowSelectForLabel = (orderId) => {
    setSelectedRows(prev => prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]);
  };

  const handleSelectAllForLabel = (checked) => {
    if (checked) setSelectedRows(paginatedData.map(row => row.order_id));
    else setSelectedRows([]);
  };

  const handleBulkShipNow = async () => {
    if (selectedRowsData.length === 0) { toast.error("Please select at least one order to ship"); return; }
    const totals = selectedRowsData.reduce((acc, row) => ({
      length: acc.length + parseFloat(row.length || 0),
      width: acc.width + parseFloat(row.shipment_width || 0),
      height: acc.height + parseFloat(row.shipment_height || 0),
      weight: acc.weight + parseFloat(row.weight || 0),
      cod_amount: acc.cod_amount + parseFloat(row.cod_amount || 0)
    }), { length: 0, width: 0, height: 0, weight: 0, cod_amount: 0 });

    const pincodeCount = {};
    selectedRowsData.forEach(row => { const pin = row.pin; if (pin) pincodeCount[pin] = (pincodeCount[pin] || 0) + 1; });
    const mostCommonPincode = Object.keys(pincodeCount).reduce((a, b) => pincodeCount[a] > pincodeCount[b] ? a : b, '');

    const requestBody = {
      from_pincode: selectedRowsData[0].pickup_pin_code,
      to_pincode: mostCommonPincode,
      length: totals.length, width: totals.width, height: totals.height, weight: totals.weight,
      shipment_type: "Forward", declared_value: "",
      payment_mode: selectedRowsData[0].payment_mode,
      cod_amount: totals.cod_amount.toString()
    };

    setIsPageLoading(true);
    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: { 'Content-Type': 'application/json', token, cus_id: cusid },
      });
      if (response.data.status === "success") {
        const enrichedBulkShipment = { ...response.data, bulk_order: true, selected_orders: selectedRowsData.map(r => r.order_id), total_orders: selectedRowsData.length, bulk_totals: totals, most_common_pincode: mostCommonPincode, selectedRowsData };
        setSelectedShipment(enrichedBulkShipment);
        setIsPopupOpenForShip(true);
        setSelectedRowsForShip([]);
        setSelectedRowsData([]);
        fetchAllShipments();
      } else { toast.error(response.data.message || "Something went wrong"); }
    } catch (error) {
      toast.error(error?.response?.data?.messages?.error || error.message || "Something Went Wrong!");
    } finally { setIsPageLoading(false); }
  };

  const handleDownload = async () => {
    if (selectedRows.length === 0) return toast.error("No orders selected");
    isSetLoading(true); setIsPageLoading(true);
    try {
      const response = await fetch(Base_Url + bulkshipmentlabel, {
        method: 'POST',
        headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_ids: selectedRows }),
      });
      const data = await response.json();
      if (data.status === "SUCCESS" && data.DownloadLink) {
        window.open(Url_For_View_Document + data.DownloadLink, "_blank");
        toast.success("Bulk labels downloaded successfully!");
        fetchAllShipments();
      } else { toast.error(data.message || "Download failed"); }
    } catch (error) { toast.error("Download failed"); }
    finally { isSetLoading(false); setIsPageLoading(false); }
  };

  const handleViewClick = (row) => { setSelectedShipment(row); setIsPopupOpen(true); };
  const handleClick = (orderID) => { setorderId(orderID); navigateForTrack("/shipments/tracking"); };

  const handleCancelOrder = async (orderId) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?', text: "Do you want to cancel this order?", icon: 'warning',
      showCancelButton: true, confirmButtonColor: '#d33', confirmButtonText: 'Yes, cancel it!',
    });
    if (!confirmResult.isConfirmed) return;
    setIsPageLoading(true);
    try {
      const response = await fetch(`${Base_Url}${deleteShipment}/${orderId}`, {
        method: 'GET', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        toast.success("Order canceled successfully!");
        fetchAllShipments();
      }
    } catch (error) { toast.error(error.message); }
    finally { setIsPageLoading(false); }
  };

  const handlePrintLabel = async (orderId) => {
    setIsPageLoading(true);
    try {
      const response = await fetch(`${Base_Url}${shipmentlabel}`, {
        method: 'POST', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_id: orderId }),
      });
      const data = await response.json();
      if (data.status === "SUCCESS" && data?.DownloadLink) {
        window.open(Base_Url + data.DownloadLink, '_blank');
        toast.success("Label downloaded successfully!");
        fetchAllShipments();
      }
    } catch (error) { toast.error('API error: ' + error.message); }
    finally { setIsPageLoading(false); }
  };

  const copyToClipboard = (text, label) => { navigator.clipboard.writeText(text); toast.success(`${label} copied!`); };

  const getStatusStyle = (status) => {
    if (!status) return 'bg-gray-100 text-gray-600';
    const s = status.toLowerCase();
    if (s.includes('failed') || s.includes('cancel')) return 'bg-red-100 text-red-700';
    if (s.includes('pending')) return 'bg-yellow-100 text-yellow-700';
    return 'bg-emerald-100 text-emerald-700';
  };

  const handleShipNow = async (data) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const requestBody = {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      address: data.address,
      product_desc: data.products_desc,
      phone: data.phone,
      city: data.city,
      state: data.state,
      country: "India",
      payment_mode: data.payment_mode,
      total_amount: data.total_amount,
      address_type: "home",
      length: data.length,
      width: data.shipment_width,
      height: data.shipment_height,
      from_pincode: data.pickup_pin_code,
      to_pincode: data.pin,
      cod_amount: data.cod_amount,
      quantity: "1",
      weight: data.weight,
      shipment_type: "Forward",
      order_id: data.order_id
    };
    setIsPageLoading(true);
    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });
      if (response.data.status === "success") {
        toast.success(response.data.message);
        const enrichedShipment = { ...response.data, order_id: data.order_id };
        handleViewClickForShip(enrichedShipment);
        fetchAllShipments();
      } else {
        toast.error(response.data.message || "Something went wrong. Please check the data.");
      }
    } catch (error) {
      const apiError = error?.response?.data?.messages?.error || error.message || "Something Went Wrong!";
      toast.error(apiError);
    } finally {
      setIsPageLoading(false);
    }
  };

  const handleViewClickForShip = (shipment) => {
    setSelectedShipment(shipment);
    setIsPopupOpenForShip(true);
  };

  const tabs = [
    { key: "all orders", label: "All Orders", icon: <FaList /> },
    { key: "Add Shipment list", label: "Pending", icon: <FaTruck /> },
    { key: "new order", label: "New Order", icon: <MdOutlinePendingActions /> },
    { key: "process order", label: "Process", icon: <FaClipboardList /> },
    { key: "manifest list", label: "Manifest", icon: <FaHourglassHalf /> },
    { key: "failed", label: "Failed", icon: <FaTimesCircle /> },
    { key: "shopify", label: "Shopify", icon: <FaShopify /> },
    { key: "woocommerce", label: "WooCommerce", icon: <SiWoocommerce /> },
  ];

  const [hoverCardPos, setHoverCardPos] = useState({
    id: null,
    above: false,
    left: 0,
    top: 0,
  });

  const handleUserMouseEnter = (e, id) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const cardWidth = 288;
    const cardHeight = 320;
    const gap = 8;
    let left = rect.left;
    let top = rect.bottom + gap;
    let above = false;
    if (window.innerHeight - rect.bottom < cardHeight) {
      top = rect.top - cardHeight - gap;
      above = true;
    }
    if (left + cardWidth > window.innerWidth - 10) {
      left = window.innerWidth - cardWidth - 10;
    }
    if (left < 10) {
      left = 10;
    }
    setHoverCardPos({ id, above, left, top });
  };

  const handleUserMouseLeave = () => {
    setHoverCardPos({ id: null, above: false, left: 0, top: 0 });
  };

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'}`}>
      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        <div className="hidden md:block w-64 border-r bg-white dark:bg-gray-900 flex-shrink-0">
          {isToggleSidebar && <Sidebar />}
        </div>

        <FullPageLoader isLoading={isPageLoading} message="Processing..." />

        <div className="flex-1 p-3 md:p-6 overflow-y-auto bg-gray-100 custom-scrollbar min-w-0">
<div className='w-full flex justify-between items-center'>
 <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 text-gray-800 dark:text-white">
            All Shipments
          </h1>
          <div className="relative w-full md:w-80 lg:w-96 flex-shrink-0">
              <CgSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              <input
                type="text"
                placeholder="Search by Order ID, Name, Phone..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2.5 md:py-3 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-2xl focus:border-blue-500 outline-none text-sm"
              />
            </div>
</div>
         

          <div className="flex flex-col md:flex-row md:items-end gap-3 md:gap-4 mb-4 md:mb-6">
            <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide flex-1">
              {tabs.map(tab => {
                const count = getTabCount(tab.key);
                const isActive = activeTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    className={`flex items-center gap-1.5 px-3 md:px-2 py-2 md:py-1.5 text-[12px] md:text-[12px] font-medium rounded-xl transition-all whitespace-nowrap flex-shrink-0
                      ${isActive
                        ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg"
                        : "bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700"
                      }`}
                  >
                    <span className="hidden sm:inline">{tab.icon}</span>
                    <span>{tab.label}</span>
                    <span className={`ml-1 px-1.5 py-0.5 text-[10px] rounded-full ${isActive ? 'bg-white/30' : 'bg-gray-200 dark:bg-gray-700'}`}>
                      {count}
                    </span>
                  </button>
                );
              })}
            </div>

            
          </div>

          {((activeTab === 'Add Shipment list' || activeTab === 'pending') && selectedRowsForShip.length > 0) || selectedRows.length > 0 ? (
            <div className="mb-4 flex gap-2 md:gap-3 flex-wrap">
              {(activeTab === 'Add Shipment list' || activeTab === 'pending') && selectedRowsForShip.length > 0 && (
                <button
                  onClick={handleBulkShipNow}
                  className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 md:px-6 py-2 md:py-3 rounded-xl flex items-center gap-2 font-medium text-sm"
                >
                  <FaShippingFast /> Ship Now ({selectedRowsForShip.length})
                </button>
              )}
              {selectedRows.length > 0 && (
                <button
                  onClick={handleDownload}
                  disabled={isloading}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-4 md:px-6 py-2 md:py-3 rounded-xl flex items-center gap-2 font-medium text-sm disabled:opacity-70"
                >
                  {isloading ? "Processing..." : <><FaDownload /> Download Labels ({selectedRows.length})</>}
                </button>
              )}
            </div>
          ) : null}

          <style>{`
            @keyframes fadeSlideIn {
              from { opacity: 0; transform: translateY(10px); }
              to   { opacity: 1; transform: translateY(0); }
            }
            .row-animate { animation: fadeSlideIn 0.35s ease both; }
            tr.row-animate:hover td { background-color: rgba(99,102,241,0.04); transition: background 0.2s; }
            .scrollbar-hide::-webkit-scrollbar { display: none; }
            .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
            @keyframes cardIn {
              from { opacity: 0; transform: translateY(12px); }
              to   { opacity: 1; transform: translateY(0); }
            }
            .card-animate { animation: cardIn 0.3s ease both; }
          `}</style>

          {isMobileCardView ? (
            <div className="flex flex-col gap-3">
              {paginatedData.length === 0 && (
                <div className="text-center py-12 text-gray-400 bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-700">
                  No orders found
                </div>
              )}
              {paginatedData.map((row, index) => {
                const isPending = row.status?.toLowerCase().includes('pending');
                const isTrackingDisabled = row.status?.toLowerCase() === "pending" || row.status?.toLowerCase() === "failed" || !row.waybill;
                const isFailed = row.status?.toLowerCase() === "failed";
                const isChecked = selectedRowsForShip.includes(row.order_id) || selectedRows.includes(row.order_id);

                return (
                  <div
                    key={row.order_id}
                    className={`card-animate rounded-2xl border p-4 shadow-sm transition-colors
                      ${isChecked
                        ? 'bg-indigo-50 dark:bg-indigo-900/20 border-indigo-200 dark:border-indigo-700'
                        : 'bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700'
                      }`}
                    style={{ animationDelay: `${index * 40}ms` }}
                  >
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => {
                            if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleRowSelectForShip(row.order_id, row);
                            else handleRowSelectForLabel(row.order_id);
                          }}
                          className="w-4 h-4"
                        />
                        <div>
                          <span
                            onClick={() => !isTrackingDisabled && handleClick(row.order_id)}
                            className={`font-bold text-sm ${isTrackingDisabled ? "text-gray-400" : "text-indigo-600"}`}
                          >
                            #{row.order_id}
                          </span>
                          {row.waybill && <div className="text-[10px] text-gray-400">AWB: {row.waybill}</div>}
                        </div>
                      </div>
                      <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${getStatusStyle(row.status)}`}>
                        {row.status}
                      </span>
                    </div>

                    <div className="grid grid-cols-2 gap-2 text-xs mb-3">
                      <div>
                        <div className="text-gray-400 mb-0.5">Customer</div>
                        <div className="font-medium text-gray-800 dark:text-gray-200">{row.first_name} {row.last_name}</div>
                        <div className="text-gray-400">{row.phone}</div>
                      </div>
                      <div>
                        <div className="text-gray-400 mb-0.5">Payment</div>
                        <div className="font-semibold text-gray-800 dark:text-gray-200">₹{row.total_amount}</div>
                        {row.payment_mode === 'cod' && <div className="text-orange-500">COD: ₹{row.cod_amount}</div>}
                      </div>
                      <div>
                        <div className="text-gray-400 mb-0.5">Origin</div>
                        <div className="font-medium text-gray-800 dark:text-gray-200">{row.pickup_city || "—"}</div>
                      </div>
                      <div>
                        <div className="text-gray-400 mb-0.5">Destination</div>
                        <div className="font-medium text-gray-800 dark:text-gray-200">{row.city || "—"}</div>
                      </div>
                      <div>
                        <div className="text-gray-400 mb-0.5">Product</div>
                        <div className="text-gray-700 dark:text-gray-300 line-clamp-1">{row.products_desc}</div>
                        <div className="text-gray-400">Qty: {row.quantity} | {row.weight}g</div>
                      </div>
                      <div>
                        <div className="text-gray-400 mb-0.5">Date</div>
                        <div className="text-gray-700 dark:text-gray-300">
                          {new Date(row.created_at).toLocaleDateString('en-IN')}
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 pt-2 border-t border-gray-100 dark:border-gray-800">
                      <button onClick={() => handleViewClick(row)} className="flex items-center gap-1.5 text-xs text-indigo-600 font-medium">
                        <FaEye size={14} /> View
                      </button>
                      {(activeTab === 'Add Shipment list' || activeTab === 'pending') && isPending && (
                        <button onClick={() => handleShipNow(row)} className="flex items-center gap-1.5 text-xs text-emerald-600 font-medium">
                          <FaShippingFast size={14} /> Ship
                        </button>
                      )}
                      {(isPending || isFailed) && (
                        <button onClick={() => handleCancelOrder(row.order_id)} className="flex items-center gap-1.5 text-xs text-red-500 font-medium">
                          <RxCross2 size={14} /> Cancel
                        </button>
                      )}
                      {!isPending && (
                        <button onClick={() => handlePrintLabel(row.order_id)} className="flex items-center gap-1.5 text-xs text-purple-600 font-medium">
                          <FaDownload size={13} /> Label
                        </button>
                      )}
                      <button onClick={() => copyToClipboard(row.order_id, "Order ID")} className="ml-auto text-gray-400">
                        <FaCopy size={13} />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse min-w-[900px]">
                  <thead>
                    <tr className="bg-slate-50 dark:bg-gray-800 border-b-2 border-indigo-200 dark:border-indigo-800">
                      <th className="py-4 px-3 w-12 border-r border-gray-200 dark:border-gray-700">
                        <input
                          type="checkbox"
                          checked={
                            (activeTab === 'Add Shipment list' || activeTab === 'pending')
                              ? selectedRowsForShip.length === paginatedData.length
                              : selectedRows.length === paginatedData.length
                          }
                          onChange={(e) => {
                            if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleSelectAllForShip(e.target.checked);
                            else handleSelectAllForLabel(e.target.checked);
                          }}
                          className="w-4 h-4"
                        />
                      </th>
                      {[
                        "Order ID",
                        ...(role === 'admin' ? ["User ID"] : []),
                        "Customer Info",
                        "Product Details",
                        "Payment",
                        "Origin",
                        "Destination",
                        "Status",
                        "Date",
                        "Actions"
                      ].map((heading) => (
                        <th
                          key={heading}
                          className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 border-r border-gray-200 dark:border-gray-700 last:border-r-0"
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                    {paginatedData.length === 0 && (
                      <tr>
                        <td colSpan={role === 'admin' ? 12 : 11} className="py-12 text-center text-gray-400">
                          No orders found
                        </td>
                      </tr>
                    )}
                    {paginatedData.map((row, index) => {
                      const isPending = row.status?.toLowerCase().includes('pending');
                      const isTrackingDisabled = row.status?.toLowerCase() === "pending" || row.status?.toLowerCase() === "failed" || !row.waybill;
                      const isFailed = row.status?.toLowerCase() === "failed";
                      const isChecked = selectedRowsForShip.includes(row.order_id) || selectedRows.includes(row.order_id);

                      return (
                        <tr
                          key={row.order_id}
                          className={`row-animate group border-b border-gray-100 dark:border-gray-800 transition-colors duration-200
                            ${isChecked ? 'bg-indigo-50 dark:bg-indigo-900/20' : 'hover:bg-gray-50 dark:hover:bg-gray-800/50'}`}
                          style={{ animationDelay: `${index * 40}ms` }}
                        >
                          <td className="py-4 px-3 text-center border-r border-gray-100 dark:border-gray-800">
                            <input
                              type="checkbox"
                              checked={
                                (activeTab === 'Add Shipment list' || activeTab === 'pending')
                                  ? selectedRowsForShip.includes(row.order_id)
                                  : selectedRows.includes(row.order_id)
                              }
                              onChange={() => {
                                if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleRowSelectForShip(row.order_id, row);
                                else handleRowSelectForLabel(row.order_id);
                              }}
                              className="w-4 h-4"
                            />
                          </td>

                          <td className="py-4 px-3 border-r border-gray-100 dark:border-gray-800">
                            <div className="flex flex-col">
                              <div className="flex items-center gap-2">
                                <span
                                  onClick={() => !isTrackingDisabled && handleClick(row.order_id)}
                                  className={`font-bold text-sm cursor-pointer ${isTrackingDisabled ? "text-gray-400" : "text-indigo-600 hover:text-indigo-800"}`}
                                >
                                  {row.order_id}
                                </span>
                                <button onClick={() => copyToClipboard(row.order_id, "Order ID")} className="opacity-0 group-hover:opacity-100 transition-opacity">
                                  <FaCopy size={12} className="text-gray-400 hover:text-gray-600" />
                                </button>
                              </div>
                              {row.waybill && <div className="text-[10px] text-gray-400 mt-0.5">AWB: {row.waybill}</div>}
                              {row.partner && (
                                <div className="text-[10px] text-gray-400 mt-0.5">
                                  {row.partner ? (
                                    <>
                                      {row.partner?.toLowerCase() === "delhivery" && (
                                        <div className="flex items-center">
                                          {isDarkMode ? (
                                            <img src="/assets/images/DELHIVERYWhite.png" alt="Delhivery" className="h-2 w-auto object-contain" />
                                          ) : (
                                            <img src="/assets/images/Delhivery.png" alt="Delhivery" className="h-2 w-auto object-contain" />
                                          )}
                                        </div>
                                      )}
                                      {row.partner?.toLowerCase() === "ecom" && (
                                        <div className="flex items-center rounded-full">
                                          {isDarkMode ? (
                                            <img src="/assets/images/logoecom.svg" alt="Ecom Express" className="h-3 w-auto object-contain" />
                                          ) : (
                                            <img src="/assets/images/ecom-express-logo.png" alt="Ecom Express" className="h-14 w-auto object-contain" />
                                          )}
                                        </div>
                                      )}
                                      {row.partner?.toLowerCase() === "ekart" && (
                                        <div className="flex items-center">
                                          <img src="/assets/images/ekart.png" alt="Ekart" className="h-9 w-auto object-contain" />
                                        </div>
                                      )}
                                      {row.partner?.toLowerCase() === "xpressbees" && (
                                        <div className="flex items-center">
                                          <img src="/assets/images/xpressbess.png" alt="xpressbess" className="h-[10px] w-auto object-contain" />
                                        </div>
                                      )}
                                      {row.partner?.toLowerCase() === "bluedart" && (
                                        <div className="flex items-center">
                                          <img src="/assets/images/bluedart.png" alt="bluedart" className="h-[10px] w-auto object-contain" />
                                        </div>
                                      )}
                                      {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart"].includes(row.partner?.toLowerCase()) && (
                                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
                                          {row.partner}
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200">
                                      Unavailable
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          </td>

                          {role === "admin" && (
                            <td className="py-4 px-3 text-sm border-r border-gray-100 dark:border-gray-800">
                              <div
                                className="relative inline-block w-full"
                                onMouseEnter={(e) => handleUserMouseEnter(e, row.order_id)}
                                onMouseLeave={handleUserMouseLeave}
                              >
                                {(() => {
                                  const retailer = row.retailerData && Object.values(row.retailerData)[0];
                                  const displayName = retailer?.name || row.first_name || row.last_name || "—";
                                  return (
                                    <div className="cursor-default">
                                      <div className="font-bold text-gray-700 dark:text-gray-200 capitalize truncate max-w-[120px]">
                                        {displayName}
                                      </div>
                                      <div className="text-[10px] text-indigo-500">
                                        #{retailer?.user_id || row.user_id}
                                      </div>
                                    </div>
                                  );
                                })()}
                              </div>
                            </td>
                          )}

                          <td className="py-4 px-3 border-r border-gray-100 dark:border-gray-800">
                            <div className="font-medium text-sm text-gray-800 dark:text-gray-200">{row.first_name} {row.last_name}</div>
                            <div className="text-xs text-gray-400 mt-0.5">{row.phone} | {row.email}</div>
                          </td>

                          <td className="py-4 px-3 border-r border-gray-100 dark:border-gray-800">
                            <div className="text-sm text-gray-800 dark:text-gray-200">{row.products_desc}</div>
                            <div className="text-xs text-gray-400 mt-0.5">Qty: {row.quantity} | Wt: {row.weight}g | {row.length}×{row.shipment_width}×{row.shipment_height} cm</div>
                          </td>

                          <td className="py-4 px-3 text-right border-r border-gray-100 dark:border-gray-800">
                            <div className="font-semibold text-sm text-gray-800 dark:text-gray-200">₹{row.total_amount}</div>
                            {row.payment_mode === 'cod' && <div className="text-xs text-orange-500 font-medium">COD: ₹{row.cod_amount}</div>}
                          </td>

                          <td className="py-4 px-3 text-xs border-r border-gray-100 dark:border-gray-800">
                            <div className="font-medium text-gray-800 dark:text-gray-200">{row.pickup_city || "—"}</div>
                            <div className="text-[10px] text-gray-400 line-clamp-1">{row.pickup_address || "—"}</div>
                          </td>

                          <td className="py-4 px-3 text-xs border-r border-gray-100 dark:border-gray-800">
                            <div className="font-medium text-gray-800 dark:text-gray-200">{row.city}</div>
                            <div className="text-[10px] text-gray-400 line-clamp-1">{row.address || "—"}</div>
                          </td>

                          <td className="py-4 px-3 text-center border-r border-gray-100 dark:border-gray-800">
                            <span className={`px-3 py-1 text-xs font-medium rounded-full ${getStatusStyle(row.status)}`}>
                              {row.status}
                            </span>
                          </td>

                          <td className="py-4 px-3 text-center text-xs text-gray-500 border-r border-gray-100 dark:border-gray-800">
                            {new Date(row.created_at).toLocaleDateString('en-IN')}
                          </td>

                          <td className="py-4 px-3 text-center">
                            <div className="flex justify-center gap-3">
                              <FaEye className="cursor-pointer text-indigo-500 hover:text-indigo-700 transition-colors hover:scale-110 transform duration-150" size={17} onClick={() => handleViewClick(row)} />
                              {(activeTab === 'Add Shipment list' || activeTab === 'pending') && isPending && (
                                <FaShippingFast className="cursor-pointer text-emerald-500 hover:text-emerald-700 transition-colors hover:scale-110 transform duration-150" size={17} onClick={() => handleShipNow(row)} />
                              )}
                              {(isPending || isFailed) && (
                                <RxCross2 className="cursor-pointer text-red-400 hover:text-red-600 transition-colors hover:scale-110 transform duration-150" size={17} onClick={() => handleCancelOrder(row.order_id)} />
                              )}
                              {!isPending && (
                                <FaDownload className="cursor-pointer text-purple-500 hover:text-purple-700 transition-colors hover:scale-110 transform duration-150" size={15} onClick={() => handlePrintLabel(row.order_id)} />
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {totalPages > 1 && (
            <div className="flex justify-center mt-6 md:mt-8">
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(e, v) => setCurrentPage(v)}
                color="primary"
                size={isMobileCardView ? "small" : "medium"}
              />
            </div>
          )}
        </div>
      </div>

      <ViewAllShipment isopen={isPopupOpen} onClose={() => setIsPopupOpen(false)} shipment={selectedShipment} />
      <ViewRateForwardShipment isopen={isPopupOpenForShip} onClose={() => setIsPopupOpenForShip(false)} data={selectedShipment} />
    </div>
  );
};

export default AllShipment;